import './App.scss';
import SideMenu from './components/Menu/side-menu';
import Home from './Home';
import CheckList from './CheckList'
import Instructions from './Instructions'
import Introduction from './Introduction'
import About from './About'
import { BrowserRouter as Router, Switch, Route, Link, } from 'react-router-dom';

export default function App() {

  return (
    <Router>
      <div style={{backgroundImage: "url('./assets/bg-gradient.png')"}}className="App">
        <SideMenu />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/introduktion" component={Introduction} />
          <Route path="/checklista" component={CheckList}/>
          <Route path="/hurfunkardet" component={Instructions}/>
          <Route path="/omoss" component={About}/>
          <Link to="Ivris.pdf"
            target="_blank" download></Link>
        </Switch>
      </div>
    </Router>
  );
}
